import { render, staticRenderFns } from "./Erp6SaleBaseProductPriceEdit.vue?vue&type=template&id=f4b419c8&scoped=true&"
import script from "./Erp6SaleBaseProductPriceEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseProductPriceEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseProductPriceEdit.vue?vue&type=style&index=0&id=f4b419c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b419c8",
  null
  
)

export default component.exports